// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EnergyTable_summary__zjr9Q {
  padding: 5px 4px;
  display: flex;
  justify-content: center;
  font-weight: bold;
  flex-direction: column;
}

.EnergyTable_separator__uaHuJ {
  border-top: 1px solid lightgray;
}`, "",{"version":3,"sources":["webpack://./src/containers/EnergyTable.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,sBAAA;AACF;;AAEA;EACE,+BAAA;AACF","sourcesContent":[".summary {\n  padding: 5px 4px;\n  display: flex;\n  justify-content: center;\n  font-weight: bold;\n  flex-direction: column;\n}\n\n.separator {\n  border-top: 1px solid lightgray;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"summary": `EnergyTable_summary__zjr9Q`,
	"separator": `EnergyTable_separator__uaHuJ`
};
export default ___CSS_LOADER_EXPORT___;
